<template>
  <v-stepper value="none" style="border-radius: 0;" class="elevation-0">
    <v-stepper-header>
      <v-stepper-step
        step="1"
        :complete="!!client.email_verified_at"
        complete-icon="mdi-progress-check"
        disabled
        class="font-weight-bold"
        >Verified Email
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step
        step="2"
        :complete="!!client.api_url"
        complete-icon="mdi-progress-check"
        class="font-weight-bold"
      >
        Deploy API
      </v-stepper-step>

      <v-divider></v-divider>
    </v-stepper-header>
  </v-stepper>
</template>
<script>
export default {
  props: {
    client: {
      required: true,
    },
  },
  computed: {
    generatedActivationCode() {
      return !!(this.client.activation_last_generated_at || this.client.activation_code);
    },
  },
};
</script>
